<template>
  <div>
    <ValidationObserver ref="observer" style="position: absolute;">
      <v-row no-gutters align="center">
        <v-col cols="auto" class="pt-8">
          <modal-cadu :close="close" :width="1101.52" v-model="show">
            <div slot="all" class="py-10 px-10">
              <div slot="header">
                <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995d;">
                  {{ getTypesText() }} ENDEREÇO
                </div>
              </div>

              <div slot="body" class="border-body" :class="$vuetify.breakpoint.xs ? 'pb-4' : ''">
                <v-row v-if="loading" align="center" justify="center" style="height: 100%;">
                  <v-col>
                    <spinner-cadu
                      :line-fg-color="$vuetify.theme.themes.light.primary1"
                      :size="100"
                      :line-size="5"
                      :speed="0.6"
                      :font-size="30"
                      :spacing="10"
                      :text-fg-color="$vuetify.theme.themes.light.fontColor"
                      message="Carregando"
                    />
                  </v-col>
                </v-row>

                <div v-else>
                  <v-row no-gutters class="pb-4">
                    <v-col cols="12" sm="10" lg="8" v-if="canCheckEnderecoPrincipal">
                      <checkbox-cadu v-model="check" :disable="disabledCheck()">
                        <div slot="text">
                          Utilizar esse endereço para remessa de correspondência principal
                        </div>
                      </checkbox-cadu>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" sm="3" lg="2" class="mr-4">
                      <validation-provider
                        name="cep"
                        mode="eager"
                        rules="required|alpha_dash|min:9"
                        v-slot="{ errors }"
                      >
                        <input-cadu
                          :errorMessage="errors[0]"
                          title="CEP"
                          v-mask="cepMask"
                          :disabled="disable"
                          v-model="cep"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                        >
                        </input-cadu>
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" sm="3" lg="3" class="mr-4">
                      <validation-provider name="endereco" mode="eager" rules="required" v-slot="{ errors }">
                        <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Tipo de Endereço"
                          :disabled="disable"
                          onlyText
                          v-model="tipoEndereco.nome"
                          :items="tiposEndereco.map((el) => el.nome)"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @input="(input) => comboIndex(input, 'ende')"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" sm="3" lg="2" class="mr-4">
                      <validation-provider name="tipoLogradouro" mode="eager" rules="required" v-slot="{ errors }">
                        <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Tipo de Logradouro"
                          :disabled="disable"
                          v-model="tipoLogradouro.nome"
                          :items="tiposLogradouros.map((el) => el.nome)"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @input="(input) => comboIndex(input, 'logra')"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" sm="4" class="mr-4">
                      <validation-provider
                        name="nomeLogradouro"
                        mode="eager"
                        rules="required|max:100"
                        v-slot="{ errors }"
                      >
                        <input-cadu
                          :errorMessage="errors[0]"
                          title="Nome do Logradouro"
                          :disabled="disable"
                          v-model="logradouro"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          :max="'100'"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" sm="2" class="mr-4">
                      <validation-provider
                        name="numeroEndereco"
                        mode="eager"
                        rules="required|max:10"
                        v-slot="{ errors }"
                      >
                        <input-cadu
                          :errorMessage="errors[0]"
                          title="Número"
                          :disabled="disable"
                          v-model="numeroEndereco"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          :max="'10'"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" sm="7" lg="7" class="mr-12">
                      <validation-provider name="complementoEndereco" mode="eager" rules="max:50">
                        <input-cadu
                          title="Complemento"
                          :disabled="disable"
                          v-model="complemento"
                          :max="'50'"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" sm="4" lg="4" class="">
                      <validation-provider name="bairro" mode="eager" rules="required" v-slot="{ errors }">
                        <input-cadu
                          :errorMessage="errors[0]"
                          title="Bairro"
                          :disabled="disable"
                          :max="'50'"
                          v-model="bairro"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" sm="2" lg="1" class="mr-4">
                      <validation-provider name="estado" mode="eager" rules="required" v-slot="{ errors }">
                        <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Estado"
                          :disabled="disable"
                          v-model="estado.sigla"
                          v-mask="'AA'"
                          :items="listaEstados.map((el) => el.sigla)"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @input="(input) => comboIndex(input, 'esta')"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" sm="5" class="mr-4">
                      <validation-provider name="municipio" mode="eager" rules="required" v-slot="{ errors }">
                        <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Município"
                          :disabled="disable || listaMunicipios.length < 1"
                          v-model="municipio.nome"
                          onlyText
                          :items="listaMunicipios.map((el) => el.nome)"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @input="(input) => comboIndex(input, 'muni')"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" sm="2" class="mt-2 mr-4">
                      <span class="span-label">Capital do Estado</span>
                      <div>
                        <switch-cadu
                          style="display: inline-block;"
                          :disabled="disable"
                          :value="capital"
                          @input="(value) => (capital = value)"
                        />
                        <span class="ml-3">{{ capital ? 'SIM' : 'NÃO' }}</span>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <validation-provider name="regiaoGeografica" mode="eager" rules="required" v-slot="{ errors }">
                        <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Região Geográfica"
                          :disabled="disable"
                          onlyText
                          v-model="regiao.nome"
                          :items="regioes.map((el) => el.nome)"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @input="(input) => comboIndex(input, 'regi')"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" class="mt-5">
                      <v-row no-gutters align="center" class="mt-2">
                        <div class="primary1--text">TELEFONE</div>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="5" md="2" class="mr-1">
                          <validation-provider
                            name="numeroTelefone"
                            mode="eager"
                            rules="required|telRequired"
                            v-slot="{ errors }"
                          >
                            <input-cadu
                              :errorMessage="errors[0]"
                              title="Número"
                              :disabled="disable"
                              onlyAlphaNum
                              v-mask="telMask"
                              v-model="numeroTelefone"
                              :colorText="$vuetify.theme.themes.light.fontColor1"
                            />
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" sm="5" md="2" class="mr-1">
                          <validation-provider name="Ramal" mode="eager" rules="numeric|max:5" v-slot="{ errors }">
                            <input-cadu
                              :errorMessage="errors[0]"
                              title="Ramal"
                              :disabled="disable"
                              onlyNumber
                              v-model="ramal"
                              :colorText="$vuetify.theme.themes.light.fontColor1"
                              :max="'5'"
                            />
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" sm="5" md="2" class="mr-1">
                          <input-cadu
                            title="Fax"
                            :disabled="disable"
                            v-model="fax"
                            :mask="faxMask"
                            onlyNumber
                            :colorText="$vuetify.theme.themes.light.fontColor1"
                          />
                        </v-col>

                        <v-col cols="12" sm="5" md="2" style="color: ;" class="mr-1">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <validation-provider
                                name="Sac"
                                mode="eager"
                                :rules="isOperadora() ? 'required' : ''"
                                v-slot="{ errors }"
                              >
                                <input-cadu
                                  :errorMessage="errors[0]"
                                  title="SAC"
                                  v-mask="sacMask"
                                  :disabled="disable"
                                  v-model="sac"
                                  onlyNumber
                                  :colorText="$vuetify.theme.themes.light.fontColor1"
                                />
                              </validation-provider>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" sm="12" md="3" class="py-10" style="color: #00995d;">
                          <div v-if="formType != 'view'">Caso necessário informe o DDD</div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div slot="footer">
                <div v-if="!$vuetify.breakpoint.xs">
                  <v-row align="center" justify="start" class="linha mt-4">
                    <v-col sm="auto" v-if="formType.toUpperCase() === 'EDIT'">
                      <button-cadu text="CANCELAR" @click="verificarMudanca" :outline="true" />
                    </v-col>

                    <v-row v-if="formType.toUpperCase() === 'VIEW'" align="end" justify="end" no-gutters class="mr-2">
                      <v-col cols="auto"> <button-cadu text="VOLTAR" @click="$emit('close')" /> </v-col>
                    </v-row>

                    <v-row
                      v-else-if="formType.toUpperCase() === 'EDIT'"
                      aligh="end"
                      justify="end"
                      no-gutters
                      class="mr-2"
                    >
                      <v-col class="mr-6" cols="12" sm="auto">
                        <button-cadu
                          text="SALVAR"
                          @click="finish(false)"
                          :backColor="$vuetify.theme.themes.light.primary1"
                        />
                      </v-col>
                    </v-row>

                    <v-row v-else align="end" justify="end" class="mr-2">
                      <v-row justify="start" class="ml-2">
                        <v-col cols="auto"> <button-cadu text="VOLTAR" @click="$emit('close')" outline /> </v-col>
                      </v-row>

                      <v-col cols="12" sm="auto">
                        <button-cadu
                          text="SALVAR E CRIAR OUTRO"
                          @click="finish(true)"
                          block
                          :backColor="$vuetify.theme.themes.light.primary2"
                          class="px-4"
                        />
                      </v-col>

                      <v-col cols="12" sm="auto">
                        <button-cadu
                          text="SALVAR"
                          @click="finish(false)"
                          :backColor="$vuetify.theme.themes.light.primary1"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </div>

                <div v-else>
                  <v-row align="center" justify="center" class="linha pt-4">
                    <v-row v-if="formType.toUpperCase() === 'ADD'" align="center" justify="center" no-gutters>
                      <v-col cols="12"> <button-cadu block text="VOLTAR" @click="$emit('close')" /> </v-col>
                    </v-row>

                    <v-row v-else-if="formType.toUpperCase() === 'EDIT'" aligh="center" justify="center" no-gutters>
                      <v-col cols="12">
                        <button-cadu
                          text="SALVAR"
                          block
                          @click="finish(false)"
                          :backColor="$vuetify.theme.themes.light.primary1"
                        />
                      </v-col>
                    </v-row>

                    <v-row v-else align="center" justify="center">
                      <v-col cols="12">
                        <button-cadu
                          text="SALVAR"
                          block
                          @click="finish(false)"
                          :backColor="$vuetify.theme.themes.light.primary1"
                        />
                      </v-col>

                      <v-col cols="12">
                        <button-cadu
                          text="SALVAR E CRIAR OUTRO"
                          @click="finish(true)"
                          block
                          :backColor="$vuetify.theme.themes.light.primary2"
                        />
                      </v-col>

                      <v-col cols="12" v-if="formType.toUpperCase() === 'NEW'">
                        <button-cadu block outline text="VOLTAR" @click="$emit('close')" />
                      </v-col>
                    </v-row>

                    <v-col cols="12" v-if="formType.toUpperCase() === 'EDIT'">
                      <button-cadu block text="CANCELAR" @click="cancelarEdicao" :outline="true" />
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>

            <error-modal v-model="error" :errObj="errObj" />
          </modal-cadu>
        </v-col>
      </v-row>
    </ValidationObserver>

    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="resetEdicao" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mask } from 'vue-the-mask'
import ListaEstados from '@/services/Dominios/ListaEstados'
import ListaMunicipios from '@/services/Dominios/ListaMunicipios'
import RegiaoGeografica from '@/services/Dominios/RegiaoGeografica'
import TipoEndereco from '@/services/Dominios/TipoEndereco'
import TipoLogradouro from '@/services/Dominios/TipoLogradouro'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'
import ValidationMixin from '@/Mixins/ValidationMixin'
import { cloneDeep } from 'lodash'

import Axios from 'axios'

export default {
  components: { ValidationProvider, ValidationObserver, ErrorModal },
  mixins: [ValidationMixin],
  directives: { mask },
  props: {
    disable: {
      type: Boolean,
      required: false,
      default: false
    },
    formType: {
      type: String,
      required: true,
      default: ''
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  destroyed() {
    this.cleanSelected()
  },
  data() {
    return {
      faxMask: '(##) ####-####',
      sacMask: '(##) #### ####',
      telMask: '(##) ####-####',
      cepMask: '#####-###',
      close: true,
      show: this.showModal,

      tipoAtuacao: '',
      enderecos: ['', '', ''],

      check: false,

      cep: '',
      tipoEndereco: {},
      tiposEndereco: [],
      tipoLogradouro: {},
      tiposLogradouros: [],
      logradouro: '',
      numeroEndereco: '',
      complemento: '',
      bairro: '',
      estado: {},
      listaEstados: [],
      municipio: {},
      listaMunicipios: [],
      capital: false,
      regiao: {},
      regioes: [],
      numeroTelefone: '',
      ramal: '',
      fax: '',
      sac: '',
      loading: true,
      objCombo: {},
      infoUnimed: {},
      visualizar: false,
      desabilitado: false,
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      buttonClose: false,
      showModalCancelar: false,
      id: -1
    }
  },
  methods: {
    async atribuirDados(data, newData = false) {
      this.loading = true

      if (newData) this.infoUnimed = cloneDeep(data)

      this.id = this.infoUnimed.id
      this.cep = this.infoUnimed.cep

      this.tipoEndereco = cloneDeep(this.infoUnimed.tipoEndereco)
      this.tipoLogradouro = cloneDeep(this.infoUnimed.tipoLogradouro)
      this.estado = cloneDeep(this.infoUnimed.municipio.regiao.estado)
      this.municipio = cloneDeep(this.infoUnimed.municipio)
      this.regiao = cloneDeep(this.infoUnimed.regiaoGeografica)

      this.logradouro = this.infoUnimed.logradouro
      this.numeroEndereco = this.infoUnimed.numero

      this.complemento = this.infoUnimed.complemento
      this.bairro = this.infoUnimed.bairro
      this.capital = this.infoUnimed.capital

      this.numeroTelefone = this.infoUnimed.telefone
      this.ramal = this.infoUnimed.ramal
      this.fax = this.infoUnimed.fax
      this.sac = this.infoUnimed.sac

      this.check = this.infoUnimed.principal
      this.desabilitado = this.infoUnimed.principal

      await this.getDominios()
      await this.loadModal()

      this.loading = false
    },
    async loadModal() {
      const municipios = new ListaMunicipios(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      this.loading = true

      await municipios
        .getMunicipio(this.estado.id)
        .then((res) => {
          this.listaMunicipios = res.data
        })
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => (this.loading = false))
    },
    async resetEdicao() {
      this.showModalCancelar = false;
      this.$emit('input', false);
      this.$emit('showModalControll', false);
      //await this.atribuirDados()
    },
    async loadNewMunicipio(id) {
      const tokenBearer = localStorage.getItem('tokenBearer')
      const municipio = new ListaMunicipios(tokenBearer, this.$appConfig.config.API)

      await municipio
        .getMunicipio(id)
        .then((res) => {
          this.listaMunicipios = res.data
        })
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async getDominios() {
      const tokenBearer = localStorage.getItem('tokenBearer')

      const estados = new ListaEstados(tokenBearer, this.$appConfig.config.API).getEstados()
      const regioes = new RegiaoGeografica(tokenBearer, this.$appConfig.config.API).getRegioes()
      const enderecos = new TipoEndereco(tokenBearer, this.$appConfig.config.API).getEnderecos()
      const logradouros = new TipoLogradouro(tokenBearer, this.$appConfig.config.API).getLogradouros()

      Axios.all([estados, regioes, enderecos, logradouros])
        .then(
          Axios.spread((...res) => {
            this.listaEstados = res[0].data
            this.regioes = res[1].data
            this.tiposEndereco = res[2].data
            this.tiposLogradouros = res[3].data
          })
        )
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async finish(boolean) {
      let responseForm = await this.$refs.observer.validate()
      if (responseForm) {
        let fax = ''
        let sac = ''
        let cep = this.cep.replace(/\D+/g, '')
        let numeroTelefone = this.numeroTelefone.replace(/\D+/g, '')

        if (this.fax != null && this.fax !== undefined) {
          fax = this.fax.replace(/\D+/g, '')
        }
        if (this.sac != null && this.sac !== undefined) {
          sac = this.sac.replace(/\D+/g, '')
        }

        let obj = {
          bairro: this.bairro,
          cep: cep,
          complemento: this.complemento,
          capital: this.capital,
          fax: fax,
          id: this.formType === 'edit' ? this.infoUnimed.id : null,
          logradouro: this.logradouro,
          municipio: {
            id: this.municipio.id,
            regiao: {
              estado: {
                id: this.estado.id
              },
              id: this.regiao.id
            }
          },
          numero: this.numeroEndereco,
          principal: this.check,
          ramal: this.ramal,
          sac,
          regiaoGeografica: {
            id: this.regiao.id
          },
          telefone: numeroTelefone,
          tipoEndereco: {
            id: this.tipoEndereco.id
          },
          tipoLogradouro: {
            id: this.tipoLogradouro.id
          }
        }

        if (boolean) {
          this.$emit('new-finalizar', obj)
        } else {
          this.$emit('finalizar', obj)
        }
      }
    },
    disabledCheck() {
      if (this.tipoEndereco.nome) {
        return this.visualizar || this.desabilitado
          ? true
          : this.tipoEndereco.nome.toLowerCase() !== 'sede administrativa'
      }
    },
    isObjectEqual() {
      const fax = this.fax ? this.fax.replace(/[^0-9.]/g, '') : null
      const sac = this.sac ? this.sac.replace(/[^0-9.]/g, '') : null
      const telefone = this.numeroTelefone ? this.numeroTelefone.replace(/[^0-9.]/g, '') : null
      const capital = this.capital
      const oldInfoUnimed = {
        id: this.id,
        cep: this.cep.replace(/[^0-9.]/g, ''),
        tipoEndereco: this.tipoEndereco,
        tipoLogradouro: this.tipoLogradouro,
        logradouro: this.logradouro,
        numero: this.numeroEndereco,
        complemento: this.complemento,
        bairro: this.bairro,
        municipio: this.municipio,
        capital,
        regiaoGeografica: this.regiao,
        telefone,
        ramal: this.ramal,
        fax,
        sac,
        principal: this.check
      }

      if (this.getDiffInObjects(oldInfoUnimed, this.infoUnimed))  { 
        return true;
      }
      return false;
    },
    verificarMudanca() {
      if (this.isObjectEqual()) {
        this.showModalCancelar = false;
        this.$emit('input', false);
      } else {
        this.showModalCancelar = true;
      }
    },
    cancelarEdicao() {
      const fax = this.fax ? this.fax.replace(/[^0-9.]/g, '') : null
      const sac = this.sac ? this.sac.replace(/[^0-9.]/g, '') : null
      const telefone = this.numeroTelefone ? this.numeroTelefone.replace(/[^0-9.]/g, '') : null
      const capital = this.capital
      const oldInfoUnimed = {
        id: this.id,
        cep: this.cep.replace(/[^0-9.]/g, ''),
        tipoEndereco: this.tipoEndereco,
        tipoLogradouro: this.tipoLogradouro,
        logradouro: this.logradouro,
        numero: this.numeroEndereco,
        complemento: this.complemento,
        bairro: this.bairro,
        municipio: this.municipio,
        capital,
        regiaoGeografica: this.regiao,
        telefone,
        ramal: this.ramal,
        fax,
        sac,
        principal: this.check
      }

      if (this.getDiffInObjects(oldInfoUnimed, this.infoUnimed))  {
        this.showModalCancelar = true;
      } else {
        this.showModalCancelar = false;
        this.$emit('input', false);
      }
    },
    /*cancelarEdicao() {
      const fax = this.fax ? this.fax.replace(/[^0-9.]/g, '') : null
      const sac = this.sac ? this.sac.replace(/[^0-9.]/g, '') : null
      const telefone = this.numeroTelefone ? this.numeroTelefone.replace(/[^0-9.]/g, '') : null
      const capital = this.capital

      const oldInfoUnimed = {
        id: this.id,
        cep: this.cep.replace(/[^0-9.]/g, ''),

        tipoEndereco: this.tipoEndereco,
        tipoLogradouro: this.tipoLogradouro,
        logradouro: this.logradouro,
        numero: this.numeroEndereco,

        complemento: this.complemento,
        bairro: this.bairro,

        municipio: this.municipio,
        capital,
        regiaoGeografica: this.regiao,

        telefone,
        ramal: this.ramal,
        fax,
        sac,

        principal: this.check
      }

      if (this.getDiffInObjects(oldInfoUnimed, this.infoUnimed)) 
        this.showModalCancelar = true
    },*/
    cleanSelected() {
      this.cep = ''
      this.tipoEndereco = {}
      this.tipoLogradouro = {}
      this.logradouro = ''
      this.numeroEndereco = ''
      this.complemento = ''
      this.bairro = ''
      this.estado = {}
      this.municipio = {}
      this.capital = false
      this.regiao = {}
      this.numeroTelefone = ''
      this.ramal = ''
      this.fax = ''
      this.sac = ''
      this.infoUnimed = {}
      this.check = false
    },
    comboIndex(input, type) {
      const fun = (element) => element.nome === input

      this.objCombo = {}

      switch (type) {
        case 'ende':
          if (this.tipoEndereco.nome)
            if (this.tipoEndereco.nome.toLowerCase() !== 'sede administrativa') this.check = false

          this.objCombo = this.tiposEndereco.find(fun)

          this.tipoEndereco.nome = input
          this.tipoEndereco.id = this.objCombo ? this.objCombo.id : -1
          break

        case 'logra':
          this.tipoLogradouro.nome = input
          this.objCombo = this.tiposLogradouros.find(fun)
          this.tipoLogradouro.id = this.objCombo ? this.objCombo.id : -1
          break

        case 'esta':
          this.estado.sigla = input
          if (input == null) this.listaMunicipios = []

          this.objCombo = this.listaEstados.find((element) => element.sigla === input)
          this.estado.id = this.objCombo ? this.objCombo.id : -1

          if (this.estado.id > 0) this.loadNewMunicipio(this.estado.id)
          break

        case 'muni':
          this.municipio.nome = input
          this.objCombo = this.listaMunicipios.find(fun)
          this.municipio.id = this.objCombo ? this.objCombo.id : -1
          break

        case 'regi':
          this.regiao.nome = input
          this.objCombo = this.regioes.find(fun)
          this.regiao.id = this.objCombo ? this.objCombo.id : -1
          break
      }
    },
    async newModal() {
      this.tipoEndereco = { nome: '', id: -1 }
      this.tipoLogradouro = { nome: '', id: -1 }
      this.estado = { nome: '', id: -1 }
      this.municipio = { nome: '', id: -1 }
      this.regiao = { nome: '', id: -1 }
      this.loading = false

      await this.getDominios()
      await this.loadModal()

      this.$forceUpdate()
    },
    isOperadora() {
      return this.tipoAtuacao.toUpperCase() === 'OPERADORA'
    },
    getTypesText() {
      if (this.formType.toUpperCase() === 'NEW') {
        this.visualizar = false
        return 'ADICIONAR'
      } else if (this.formType.toUpperCase() === 'EDIT') {
        this.visualizar = false
        return 'EDITAR'
      } else {
        this.visualizar = true
        return 'VISUALIZAR'
      }
    },
    onlyView() {
      return this.formType.toUpperCase() === 'NEW' || this.formType.toUpperCase() === 'EDIT'
    },
    startMask(value) {
      if (value) {
        return (
          value.startsWith('(08) 00') ||
          value.startsWith('(03) 00') ||
          value.startsWith('0800') ||
          value.startsWith('0300') ||
          value.startsWith('080') ||
          value.startsWith('030') ||
          value.startsWith('08') ||
          value.startsWith('03')
        )
      }
      return false
    }
  },
  computed: {
    canCheckEnderecoPrincipal() {
      if (this.tipoEndereco.id === 2) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    async show() {
      if (!this.show) {
        this.infoUnimed = {}
        await this.cleanSelected()
        this.$emit('close')
      }
    },
    showModal() {
      this.show = this.showModal

      if (!this.show) {
        this.infoUnimed = {}
        this.cleanSelected()
      }
    },
    sac() {
      if (this.sac) {
        if (this.startMask(this.sac)) {
          this.sacMask = '#### ### ####'
        } else if (this.sac.length > 14) {
          this.sacMask = '(##) ####-####'
        } else if (this.sacMask.length <= 14) {
          this.sacMask = '(##) ####-####'
        }
      }
    },
    numeroTelefone() {
      if (this.numeroTelefone) {
        if (this.startMask(this.numeroTelefone)) {
          this.telMask = '#### ### ####'
        } else if (this.numeroTelefone.length > 14) {
          this.telMask = '(##) #####-####'
        } else if (this.numeroTelefone.length <= 14) {
          this.telMask = '(##) ####-#####'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.span-label {
  color: rgb(96, 101, 108);
  font-size: 1rem;
  margin-left: 1px;
  margin-bottom: 2px;
}
</style>

<style scoped>
.border-body {
  border-bottom: 1px solid #9e9e9e80;
}

@media (min-width: 960px) {
  .novo-flex {
    flex: 0 0 11.6666666667%;
    max-width: 11.6666666667%;
  }

  .novo-flex-second {
    flex: 0 0 14.6666666667%;
    max-width: 14.6666666667%;
  }
}
</style>
